import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./transparencia.css";
import { transparencia_item } from "../../json/transparenciaItem";
import SelectLink from "../SelectLink/SelectLink";
const Transparencia = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Transparencia</h1>
          </div>
        </div>
      </div>
      <div className="row">
        {transparencia_item.map((item, index) => (
          <div className="col-md-4 col-sm-6 col-12 p-3" key={index}>
            <div className="transparencia_item card">
              <div className="card-body text-center">
                
                {item?.transparencia_item_select ? 
                   <SelectLink 
                     label={item.transparencia_item_nombre}
                     options={item.transparencia_item_select}
                     defaultOption="Transparencia"
                     linkPrefix="/Transparencia/Licitaciones"
                   />
                 : 
                  <Link to={item.transparencia_item_url} target={item?.target? item.target : "_self"} >
                    {item.transparencia_item_nombre}
                  </Link>
                }
              </div>
            </div>
          </div>
        ))}
        
      </div>
    </div>
  );
};

export default Transparencia;
